// extracted by mini-css-extract-plugin
module.exports = {"tagline_section":"page_tagline_section__gz8Hf","gradient_primary":"page_gradient_primary__wBi_U","gradient_accent":"page_gradient_accent__N1Nl8","mission":"page_mission__n_nLJ"};